
namespace RedBullMOBILE360.SMSCodes {
    export class SubscriptionCodesColumns {
        static columnsKey = 'SMSCodes.SubscriptionCodes';
    }
}